export function unwrap(response) {
  let value = response && response.data !== undefined ? response.data : response;
  if (value && value.data !== undefined) value = value.data;
  if (value && value.response !== undefined) value = value.response;
  return value;
}

export function rowsFrom(response) {
  const value = unwrap(response);
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== "object") return [];
  for (const key of ["list", "items", "data", "kunjungan", "rujukan", "antrean"]) {
    if (Array.isArray(value[key])) return value[key];
  }
  return [];
}

export function errorMessage(error, fallback = "Permintaan tidak dapat diproses.") {
  const data = error && error.response
    ? error.response.data
    : error && error.data
      ? error.data
      : error;
  if (data && data.message) return data.message;
  if (data && data.metaData && data.metaData.message) return data.metaData.message;
  if (data && data.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors).flat()[0];
    if (first) return first;
  }
  if (error && error.message) return error.message;
  return fallback;
}

export function displayValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Ya" : "Tidak";
  if (typeof value === "object") return JSON.stringify(value);
  return value;
}

export function today() {
  return window.medhopToday();
}
